const $ = require('jquery');
require('plugin.tooltip');
const config = {
  myCartSelector: '#headerCart',
  myAccountSelector: '#headerMyAccount',
};

class HeaderToolTips {
  constructor() {
    this._closeHeaderTooltips = this._closeHeaderTooltips.bind(this);
    this.isStickyHeaderEnabled = false;
  }

  _closeHeaderTooltips() {
    $(config.myCartSelector).tooltip('close');
    $(config.myAccountSelector).tooltip('close');
  }

  _breakpointChanged = (event, data) => {
    if (data.channel === 'MOBILE') {
      this._closeHeaderTooltips();
    }
  };

  _openingHeaderToolTip = (event, data) => {
    $('.ma-profile__caret').toggleClass('ma-profile__caret--open');
    const headerElement = document.querySelector('.Header3');
    let isStickyHeader = false;
    if (headerElement) {
      isStickyHeader = headerElement.classList.contains(
        'Header3-sticky-desktop',
      );
      if (isStickyHeader) {
        $('.ToolTip').css({ position: 'fixed' });
      } else {
        $('.ToolTip').css({ position: 'absolute' });
      }
    }
    $(window).scroll(function () {
      $('.ToolTip').css('z-index', 99);
    });
    $(document).trigger('showSimpleFlyout', false);
    $(document).trigger('closeAllMenus');

    if (data !== 'storefinder') {
      $(document).trigger('closeStoreFinder', false);
    }

    if (data === 'storefinder' || data === 'myaccount') {
      this._modifyTooltip(data);
    }
  };

  _modifyTooltip = (data) => {
    setTimeout(function () {
      var toolTipElement = $('#headerMyAccountDropdown');
      var toolTipContainer = toolTipElement.parents('.ToolTip');
      toolTipContainer.addClass('header-tooltip-zindex');
      toolTipContainer.css('bottom', 'auto');
      if (
        toolTipContainer
          .children('.ToolTip__arrow')
          .hasClass('ToolTip__arrow--top')
      ) {
        toolTipContainer
          .children('.ToolTip__content')
          .removeClass('ToolTip__content--top')
          .addClass('ToolTip__content--bottom');
        toolTipContainer
          .children('.ToolTip__wrapper')
          .removeClass('ToolTip__wrapper--top')
          .addClass('ToolTip__wrapper--bottom');
        toolTipContainer
          .children('.ToolTip__arrow')
          .removeClass('ToolTip__arrow--top')
          .addClass('ToolTip__arrow--bottom');
        toolTipContainer
          .removeClass('ToolTip--top')
          .addClass('ToolTip--bottom');
      }
    }, 50);
  };

  init() {
    $(document)
      .on('closeHeaderTooltips searchState', this._closeHeaderTooltips)
      .on('breakpointChanged', this._breakpointChanged)
      .on('openingHeaderToolTip', this._openingHeaderToolTip);
  }
}

module.exports = new HeaderToolTips();
